import React from "react";
import {useSelector} from "react-redux";
import {css, cx} from "@panda/css";

import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {IRPStore} from "../app/rp_reducer";
import {ViewType} from "../view_type/ViewType";
import {SeoMainHeadline} from "./SeoMainHeadline";

interface IProps {
    address: string;
    badges?: React.ReactNode;
    cta?: React.ReactNode;
    ctaClassName?: string;
    externalLinks?: React.ReactNode;
    onLocationClick: () => void;
    title: React.ReactNode;
    slogan?: string | null;
    addressRowButton?: React.ReactNode;
    isSpain?: boolean;
    offerType?: number;
    addressWithPointer?: boolean;
    additionalInformation?: React.ReactNode;
    mainContentClassName?: string;
    mainHeadlineClassName?: string;
}

export const DetailViewHeader = (props: IProps) => {
    const {addressWithPointer = true} = props;
    const viewType = useSelector((state: IRPStore) => state.viewType.current);

    return (
        <div className={detailViewHeaderStyle}>
            <div className={detailsWrapperStyle}>
                <div className={cx(headingStyle, props.mainContentClassName)}>
                    {viewType === ViewType.OFFER ? (
                        <SeoMainHeadline
                            as="h1"
                            variant="headline_2"
                            className={cx(mainHeadlineStyle, props.mainHeadlineClassName)}
                            dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OFFER_NAME}
                        >
                            {props.title}
                        </SeoMainHeadline>
                    ) : (
                        <Text
                            as="h1"
                            variant="headline_2"
                            className={cx(mainHeadlineStyle, props.mainHeadlineClassName)}
                            dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OFFER_NAME}
                        >
                            {props.title}
                        </Text>
                    )}

                    <div className={cx(ctaStyle, props.ctaClassName)}>{props.cta}</div>
                </div>
                <div className={badgesAndSloganWrapperStyle}>
                    {props.badges && <div className={badgesWrapperStyle}>{props.badges}</div>}

                    {props.slogan && <Text className={sloganStyle}>{props.slogan}</Text>}
                </div>
                {props.additionalInformation && <div className={marginBottom2Style}>{props.additionalInformation}</div>}

                {props.externalLinks && <div className={marginBottom2Style}>{props.externalLinks}</div>}

                <h2
                    className={cx(addressWrapperStyle, addressWithPointer && addressWrapperPointerStyle)}
                    onClick={props.onLocationClick}
                    data-testid={OFFER_TEST_IDS.OFFER_VIEW.OFFER_LOCATION}
                >
                    <div className={addressContentStyle}>
                        <MapMarkerOutlineIcon className={mapMarkerIconStyle} size="1.6" />
                        <Text variant="body_copy_1">{props.address}</Text>
                    </div>
                    {props.addressRowButton}
                </h2>
            </div>
        </div>
    );
};

const detailViewHeaderStyle = css({
    display: "flex",
    position: "relative",
    flexWrap: "wrap",
    width: "100%",
    md: {
        flexWrap: "nowrap"
    }
});

const detailsWrapperStyle = css({
    flex: 1,
    paddingTop: 2,
    paddingBottom: 1.5,
    gap: 1,
    md: {
        flexGrow: 1,
        flexShrink: 1,
        marginBottom: 0
    }
});

const headingStyle = css({
    display: "flex",
    flexWrap: "wrap",
    paddingTop: 0.5,
    rowGap: 2
});

const mainHeadlineStyle = css({
    flex: "1 1 calc(100% - 1000px)"
});

const ctaStyle = css({
    display: "flex",
    flex: "0 0 auto",
    alignItems: "flex-start"
});

const badgesWrapperStyle = css({
    flex: "1 0 100%",
    marginTop: 2,
    marginBottom: 2,
    display: "flex",
    columnGap: 2
});

const badgesAndSloganWrapperStyle = css({
    display: "flex",
    flexDirection: "column"
});

const sloganStyle = css({
    flex: "1 0 100%",
    marginBottom: 2,
    mt: 2,

    md: {
        mt: 0
    }
});

const marginBottom2Style = css({
    marginBottom: 2
});

const addressWrapperStyle = css({
    display: "flex",
    alignItems: "flex-start",
    fontStyle: "normal",
    gap: 2,
    flexDirection: "column",
    margin: 0,
    md: {
        alignItems: "center",
        flexDirection: "row"
    }
});

const addressWrapperPointerStyle = css({
    cursor: "pointer"
});

const addressContentStyle = css({
    display: "flex",
    alignItems: "center"
});

const mapMarkerIconStyle = css({
    marginRight: 1
});
import React from "react";
import {useSelector} from "react-redux";
import {css, cx} from "@panda/css";

import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {IRPStore} from "../app/rp_reducer";
import {ViewType} from "../view_type/ViewType";
import {SeoMainHeadline} from "./SeoMainHeadline";

interface IProps {
    address: string;
    badges?: React.ReactNode;
    cta?: React.ReactNode;
    ctaClassName?: string;
    externalLinks?: React.ReactNode;
    onLocationClick: () => void;
    title: React.ReactNode;
    slogan?: string | null;
    addressRowButton?: React.ReactNode;
    isSpain?: boolean;
    offerType?: number;
    addressWithPointer?: boolean;
    additionalInformation?: React.ReactNode;
    mainContentClassName?: string;
    mainHeadlineClassName?: string;
}

export const DetailViewHeader = (props: IProps) => {
    const {addressWithPointer = true} = props;
    const viewType = useSelector((state: IRPStore) => state.viewType.current);

    return (
        <div className={detailViewHeaderStyle}>
            <div className={detailsWrapperStyle}>
                <div className={cx(headingStyle, props.mainContentClassName)}>
                    {viewType === ViewType.OFFER ? (
                        <SeoMainHeadline
                            as="h1"
                            variant="headline_2"
                            className={cx(mainHeadlineStyle, props.mainHeadlineClassName)}
                            dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OFFER_NAME}
                        >
                            {props.title}
                        </SeoMainHeadline>
                    ) : (
                        <Text
                            as="h1"
                            variant="headline_2"
                            className={cx(mainHeadlineStyle, props.mainHeadlineClassName)}
                            dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OFFER_NAME}
                        >
                            {props.title}
                        </Text>
                    )}

                    <div className={cx(ctaStyle, props.ctaClassName)}>{props.cta}</div>
                </div>
                <div className={badgesAndSloganWrapperStyle}>
                    {props.badges && <div className={badgesWrapperStyle}>{props.badges}</div>}

                    {props.slogan && <Text className={sloganStyle}>{props.slogan}</Text>}
                </div>
                {props.additionalInformation && <div className={marginBottom2Style}>{props.additionalInformation}</div>}

                {props.externalLinks && <div className={marginBottom2Style}>{props.externalLinks}</div>}

                <h2
                    className={cx(addressWrapperStyle, addressWithPointer && addressWrapperPointerStyle)}
                    onClick={props.onLocationClick}
                    data-testid={OFFER_TEST_IDS.OFFER_VIEW.OFFER_LOCATION}
                >
                    <div className={addressContentStyle}>
                        <MapMarkerOutlineIcon className={mapMarkerIconStyle} size="1.6" />
                        <Text variant="body_copy_1">{props.address}</Text>
                    </div>
                    {props.addressRowButton}
                </h2>
            </div>
        </div>
    );
};

const detailViewHeaderStyle = css({
    display: "flex",
    position: "relative",
    flexWrap: "wrap",
    width: "100%",
    md: {
        flexWrap: "nowrap"
    }
});

const detailsWrapperStyle = css({
    flex: 1,
    paddingTop: 2,
    paddingBottom: 1.5,
    gap: 1,
    md: {
        flexGrow: 1,
        flexShrink: 1,
        marginBottom: 0
    }
});

const headingStyle = css({
    display: "flex",
    flexWrap: "wrap",
    paddingTop: 0.5,
    rowGap: 2
});

const mainHeadlineStyle = css({
    flex: "1 1 calc(100% - 1000px)"
});

const ctaStyle = css({
    display: "flex",
    flex: "0 0 auto",
    alignItems: "flex-start"
});

const badgesWrapperStyle = css({
    flex: "1 0 100%",
    marginTop: 2,
    marginBottom: 2,
    display: "flex",
    columnGap: 2
});

const badgesAndSloganWrapperStyle = css({
    display: "flex",
    flexDirection: "column"
});

const sloganStyle = css({
    flex: "1 0 100%",
    marginBottom: 2,
    mt: 2,

    md: {
        mt: 0
    }
});

const marginBottom2Style = css({
    marginBottom: 2
});

const addressWrapperStyle = css({
    display: "flex",
    alignItems: "flex-start",
    fontStyle: "normal",
    gap: 2,
    flexDirection: "column",
    margin: 0,
    md: {
        alignItems: "center",
        flexDirection: "row"
    }
});

const addressWrapperPointerStyle = css({
    cursor: "pointer"
});

const addressContentStyle = css({
    display: "flex",
    alignItems: "center"
});

const mapMarkerIconStyle = css({
    marginRight: 1
});
